// extracted by mini-css-extract-plugin
export var hamburger = "Hamburger-module--hamburger--H715Z";
export var menuToggleAnimation = "Hamburger-module--menu-toggle-animation--70cYI";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var toggle_bottom_line = "Hamburger-module--toggle_bottom_line--AU5id";
export var toggle_top_line = "Hamburger-module--toggle_top_line--p-KoN";
export var toggled = "Hamburger-module--toggled--iPGDX";
export var white = "Hamburger-module--white--jxykk";